import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanJoseConfig } from "./data";

export default function SanJosePage() {
  return <CityPageTemplate config={sanJoseConfig} />;
}